import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface initialState {
  amount: string;
}
const initialState: initialState = {
  amount: "",
};

const amountSlice = createSlice({
  name: "amount",
  initialState: initialState,
  reducers: {
    setAmount: (state, action: PayloadAction<Partial<initialState>>) => {
      state.amount = action.payload.amount || "";
    },
    resetAmount: (state) => {
      state.amount = "";
    },
  },
});

export const { setAmount, resetAmount } = amountSlice.actions;
export default amountSlice.reducer;
